import styled from 'styled-components';
import { CatalogButton as CatalogButtonBase } from '../../../../catalog/CatalogButton';

export const CatalogButton = styled(CatalogButtonBase)
    .withConfig({ displayName: 'CatalogButton' })
    .attrs((props) => ({
        ...props,
        size: 'm',
        outlineIcon: true,
        width: '100%',
    }))``;
